import React from 'react';
import { Button, ButtonGroup, Collapse, Table } from 'reactstrap';
import SidebarPanel from './SidebarPanel';
import ElementStatistics from './ElementStatistics';
import DownloadLink from './DownloadLink';
import StatisticsFormatter from '../helpers/StatisticsFormatter';

const _imageExtensions = ['png', 'svg', 'tiff', 'tif', 'jpeg', 'jpg'];

export default class StatisticsPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      elementSort: 'alpha-asc',
      elements: true,
      characters: true,
      images: true,
    };
  }

  getFiles = () => {
    return this.props.files ? this.props.files : [];
  }

  toggle = (stype) => {
    const newState = {};
    newState[stype] = !this.state[stype];
    this.setState(newState);
  }

  collapseButton = stype => (<Button
    color="secondary"
    data-bs-toggle="collapse"
    href={`#${stype}`}
    aria-expanded="true"
    aria-controls={stype}
    onClick={() => this.toggle(stype)}
    style={{ width: '90px' }}
    title={this.state[stype] ? 'collapse' : 'expand'}
  >
    {this.state[stype] ? 'Collapse' : 'Expand'}
  </Button>)

  elementsTable(data) {
    return (<ElementStatistics
      data={data}
    />);
  }

  unicodeSearch(cp) {
    const codepoint = /^U?\+?(.+)/i;
    const match = codepoint.exec(cp);
    return `\\x\{${match[1]}\}`;
  }

  charactersTable = data => (<div className="stats-section">
    <h3>
        Special Characters
        {this.collapseButton('characters')}
    </h3>
    <div id="characters" className="collapse show">
      <p className="pb-0">
        <small>The <strong>Search</strong> field is the regular expression search for the character in Sublime Text.</small>
      </p>
      <p className="pt-0">
        <small><strong>Special characters: </strong></small>
        <code>
          {data.map(datum => datum.character).join(" | ")}
        </code>
      </p>
      <Table className="stats-table" size="sm" hover responsive>
        <thead>
          <tr>
            <th>Character</th>
            <th>Name</th>
            <th>Codepoint</th>
            <th>Block</th>
            <th>Search</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {data.map((datum, index) =>
              (<tr key={`char${index}`}>
                <td>{datum.character}</td>
                <td>{datum.name}</td>
                <td>{datum.codepoint}</td>
                <td>{datum.block}</td>
                <td>
                  <code>
                    {this.unicodeSearch(datum.codepoint)}
                  </code>
                </td>
                <td>{datum.count}</td>
              </tr>),
            )}
        </tbody>
      </Table>
    </div>
  </div>)

  static get imageExtensions() {
    return _imageExtensions;
  }

  hasImage = (dat) => {
    const name = dat.name || dat.file_name;
    if (!name) { return false; }
    const matched = this.getFiles().find((f) => {
      const noExt = name.replace(/\.[^/.]+$/, '').toLowerCase();
      const compare = f.name.toLowerCase();
      for (let i = 0; i < StatisticsPanel.imageExtensions.length; i++) {
        if (compare === `${noExt}.${StatisticsPanel.imageExtensions[i]}`) { return true; }
      }
      return false;
    });
    return matched;
  }

  imageName(datum) {
    const name = datum.name || datum.file_name || datum.query || '';
    return name;
    // return name.replace('~I', '~' + '\ufeff' + '\ufeff' + 'I');
  }

  imagesTable = data => (<div className="stats-section">
    <h3>
        Images
        {this.collapseButton('images')}
    </h3>
    <div id="images" className="collapse show">
      <p>
        <small>Image names in yellow have not been uploaded to the project.</small>
      </p>
      <Table className="stats-table" hover responsive>
        <tbody>
          {data.map((datum, index) =>
              (<tr
                key={`img${index}`}
                className={this.hasImage(datum) ? '' : 'table-warning'}
              >
                <td style={{ fontVariant: 'none' }}>{this.imageName(datum)}</td>
              </tr>),
            )}
        </tbody>
      </Table>
    </div>
  </div>)

  renderIfDefined = (type, callback) => {
    const data = this.props.statistics[type];
    if (!!data && !(data.length === 0)) {
      return callback(data);
    }
  }

  formattedStatistics = () => {
    const formatter = new StatisticsFormatter(
      this.getFileName(),
      this.props.statistics
    )
    return formatter.toText();
  }

  getFileName = () => {
    return this.props.filename || '';
  }

  statsFileName = () => {
    return this.getFileName().replace(/\.[^\.]+/, '')
      .replace(/\s+/, '-') + '-stats.txt'
  }

  downloadButton = () => (<DownloadLink
    title={`download statistics for ${this.getFileName()}`}
    filename={this.statsFileName()}
    label={<i className="fa fa-download" />}
    exportFile={this.formattedStatistics}
  />)

  render() {
    return (<SidebarPanel
      title={`Statistics for ${this.props.filename}`}
      download={this.downloadButton()}
      dismiss={this.props.dismiss}
    >
      <p className="single-stat"><strong>Word Count: </strong> {this.props.statistics.word_count} </p>
      <p className="single-stat"><strong>Character Count: </strong> {this.props.statistics.character_count} </p>
      {this.renderIfDefined('elements', this.elementsTable)}
      {this.renderIfDefined('special_characters', this.charactersTable)}
      {this.renderIfDefined('images', this.imagesTable)}
    </SidebarPanel>);
  }
}
